import { useEffect, useState } from "react";
import { Container } from "../../../shared";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const stats = [
  {
    label: "Drone Tech Multi State Cooperative Society",
    link: "https://dronetechcoop.com",
    title: "Drone Tech Multi State Co-operative Society",
    description:
      "Drone Tech Multi-State Co-operative Society Limited has been established to create an organized, inclusive and future-ready ecosystem for the drone sector.",
    image: "/banners/drone-registration.webp",
  },
  {
    label: "Market Place",
    link: "/product/all-drone",
    title: "One Place. All Drone Solutions.",
    description:
      "A seamless drone marketplace connecting buyers, sellers, and service providers nationwide, enabling efficient transactions, verified listings, and scalable drone business opportunities.",
    image: "/banners/market-place.webp",
  },
  {
    label: "DGCA Approved RPTOs",
    link: "/training-courses/1",
    title: "Certified Training Programs",
    description:
      "Get trained by DGCA-approved RPTOs across India, gaining certified skills, hands-on experience, and industry-ready expertise for professional drone operations nationwide.",
    image: "/banners/rpto.webp",
  },
  {
    label: "DSK - Drone Suvidha Kendra",
    link: "https://avplinternational.com/dsk",
    title: "Drone Suvidha Kendras",
    description:
      "Access Drone Suvidha Kendras across regions, enabling local drone services, operational support, and entrepreneurship opportunities within India’s growing drone ecosystem.",
    image: "/banners/dsk.webp",
  },
  {
    label: "Drone City Haryana",
    link: "https://dronecityharyana.com/",
    title: "Drone City Haryana Initiative",
    description:
      "Explore Haryana’s drone ecosystem hub, integrating manufacturing, training, and innovation across India’s fast-growing drone technology and infrastructure landscape.",
    image: "/banners/drone-city.webp",
  },
  {
    label: "Drone Services",
    link: "/daas-service-page",
    title: "End-to-End Drone Services",
    description:
      "From aerial surveys to advanced analytics, access complete drone service solutions designed for efficiency, accuracy, and scalable operations across diverse industries.",
    image: "/banners/drone-services.webp",
  },
];
const stats1 = [
  {
    label: "Market Place",
    link: "/product/all-drone",
    title: "One Place. All Drone Solutions.",
    description:
      "A seamless drone marketplace connecting buyers, sellers, and service providers nationwide, enabling efficient transactions, verified listings, and scalable drone business opportunities.",
    image: "/banners/banner1.jpg",
  },
  {
    label: "Drone Registration",
    link: "/vendor-onboarding",
    title: "Hassle-Free Drone Registration",
    description:
      "Streamline drone registration with secure, regulation-compliant systems, enabling faster approvals, legal operations, and seamless participation in India’s evolving drone marketplace.",
    image: "/banners/banner2.jpg",
  },
  {
    label: "DGCA Approved RPTOs",
    link: "/training-courses/1",
    title: "Certified Training Programs",
    description:
      "Get trained by DGCA-approved RPTOs across India, gaining certified skills, hands-on experience, and industry-ready expertise for professional drone operations nationwide.",
    image: "/banners/banner3.jpg",
  },
  {
    label: "DSK - Drone Suvidha Kendra",
    link: "/dsk",
    title: "Drone Suvidha Kendras",
    description:
      "Access Drone Suvidha Kendras across regions, enabling local drone services, operational support, and entrepreneurship opportunities within India’s growing drone ecosystem.",
    image: "/banners/banner4.jpg",
  },
  {
    label: "Drone City Haryana",
    link: "/drone-city",
    title: "Drone City Haryana Initiative",
    description:
      "Explore Haryana’s drone ecosystem hub, integrating manufacturing, training, and innovation across India’s fast-growing drone technology and infrastructure landscape.",
    image: "/banners/banner5.jpg",
  },
  {
    label: "Drone Services",
    link: "/daas-service-page",
    title: "End-to-End Drone Services",
    description:
      "From aerial surveys to advanced analytics, access complete drone service solutions designed for efficiency, accuracy, and scalable operations across diverse industries.",
    image: "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429",
  },
];

/* Reusable Stat Card */
const StatCard = ({ stat, index, activeIndex }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => {
        if (stat.link.startsWith("http")) {
          window.open(stat.link, "_blank");
        } else {
          navigate(stat.link);
        }
      }}
      className={`w-full flex-1 min-h-[56px] px-4 rounded-md text-sm font-medium transition border-none outline-none flex items-center justify-center ${activeIndex === index
        ? "bg-[#ebcc21] text-[#003580]"
        : "bg-[#003580] text-white hover:bg-[#002a66]"
        }`}
    >
      {stat.label}
    </button>
  );
};

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // const extendedImages = [...images, images[0]];
  const activeStat = stats[activeIndex];

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % stats.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <section className="py-3">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-6 gap-3 lg:gap-4 items-center lg:items-stretch">
          {/* LEFT STATS (desktop only position) */}
          <div className="hidden lg:flex flex-col gap-3 h-full">
            {stats.slice(0, 3).map((stat, index) => (
              <StatCard
                key={index}
                stat={stat}
                index={index}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
              />
            ))}
          </div>

          {/* HERO */}
          <div
            className="lg:col-span-4 relative bg-[#0B3C6D] rounded-md overflow-hidden h-full min-h-[206px] lg:min-h-[220px]"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            {/* Background */}
            <div
              className="absolute inset-0 bg-cover bg-center transition-all duration-700"
              style={{ backgroundImage: `url(${activeStat.image})` }}
            />

            {/* {isPaused && (
              <div className="absolute top-3 right-3 text-xs bg-[#ebcc21] px-2 py-1 rounded text-[#003580]">
                Paused
              </div>
            )} */}

            <div className="absolute inset-0 bg-gradient-to-r from-[#0B3C6D] via-[#0B3C6D]/80 to-transparent" />

            {/* Content */}
            <div className="relative h-full flex flex-col justify-center px-3 lg:px-4 py-3 text-white max-w-2xl gap-3">
              {/* <p className="text-[10px] sm:text-xs tracking-widest uppercase text-[#FFDF20] font-medium">
                Government of India | Haryana Initiative
              </p> */}

              <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl font-bold leading-tight">
                {activeStat.title}
              </h1>

              <p className="text-xs sm:text-sm text-gray-200 max-w-xl">
                {activeStat.description}
              </p>

              <div className="flex flex-wrap gap-3 pt-2">
                <Link
                  // to={activeStat.link}
                  to="/vendor-onboarding"
                  className="bg-[#ebcc21] border-none text-[#003580] px-4 py-2 rounded-md text-sm sm:text-base font-bold"
                >
                  Join Us
                </Link>
                {/* <Link
                  to="DroneXplore"
                  className="bg-transparent text-white border border-white/70 px-4 py-2 rounded-md text-sm sm:text-base font-bold"
                >
                  Learn More
                </Link> */}
              </div>
            </div>
          </div>

          {/* RIGHT STATS */}
          <div className="hidden lg:flex flex-col gap-3 h-full">
            {stats.slice(3, 6).map((stat, index) => (
              <StatCard
                key={index}
                stat={stat}
                index={index + 3}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
              />
            ))}
          </div>
        </div>

        {/* MOBILE + TABLET STATS */}
        <div className="grid grid-cols-2 gap-4 mt-6 lg:hidden">
          {stats.map((stat, index) => (
            <StatCard
              key={index}
              stat={stat}
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
            />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Hero;